var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-device-view animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "lbv-heading" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("b-card", [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-lg-12" }, [
                      _vm.deviceData.isVIP === "1" &&
                      _vm.PERMISSIONS.STATIC[_vm.$store.getters.roleID].isVip
                        ? _c("img", {
                            staticClass: "lbv-vip",
                            attrs: { src: "static/img/vip.svg" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h1", { staticClass: "lbv-page-title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.deviceData.fname) +
                            " " +
                            _vm._s(_vm.deviceData.lname) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "lbv-partner-name" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.deviceData.tenantName) +
                            " "
                        ),
                        _c("span", { staticClass: "campaignID" }, [
                          _vm._v(_vm._s(_vm.campaignID)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 lbv-static-view deets" },
                      [
                        _vm.PERMISSIONS.STATIC[_vm.$store.getters.roleID]
                          .deviceInfo
                          ? _c("ul", { staticClass: "lbv-device-info" }, [
                              _vm.PERMISSIONS.STATIC[_vm.$store.getters.roleID]
                                .address_1
                                ? _c("li", { staticClass: "item" }, [
                                    _c("i", {
                                      staticClass: "icon-location-pin",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("obtain")(
                                              _vm.deviceData.address_1,
                                              {
                                                property: "address",
                                                roleID:
                                                  _vm.$store.getters.roleID,
                                              }
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.PERMISSIONS.STATIC[_vm.$store.getters.roleID]
                                .postcode
                                ? _c("li", { staticClass: "item" }, [
                                    _c("i", {
                                      staticClass: "icon-location-pin",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("obtain")(
                                              _vm.deviceData.postcode,
                                              {
                                                property: "postcode",
                                                roleID:
                                                  _vm.$store.getters.roleID,
                                              }
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.PERMISSIONS.STATIC[_vm.$store.getters.roleID]
                                .mobile_number
                                ? _c("li", { staticClass: "item" }, [
                                    _c("i", {
                                      staticClass: "icon-screen-smartphone",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("obtain")(
                                              _vm.deviceData.mobile_number,
                                              {
                                                property: "mobile number",
                                                roleID:
                                                  _vm.$store.getters.roleID,
                                              }
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 lbv-static-view deets" },
                      [
                        _vm.PERMISSIONS.STATIC[_vm.$store.getters.roleID]
                          .customerStatus
                          ? _c("ul", { staticClass: "lbv-device-info" }, [
                              _c("li", { staticClass: "item" }, [
                                _c(
                                  "span",
                                  { staticClass: "label app-status" },
                                  [_vm._v("App Status:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("appLabel")(
                                        _vm.deviceData.customerStatus
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("LeakBot ID:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.deviceData.leakbotId)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.PERMISSIONS.STATIC[_vm.$store.getters.roleID]
                                .serialNumber
                                ? _c("li", { staticClass: "item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("Serial Number:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.deviceData.serialNumber)
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("li", { staticClass: "item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Device Type:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.deviceData.device_type)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("      "),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Firmware version:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.deviceParameters.firmwareVersion)
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.PERMISSIONS.STATIC[_vm.$store.getters.roleID]
                        .deviceStatus && _vm.statusReady
                        ? _c(
                            "div",
                            { staticClass: "col-lg-6 lbv-static-view" },
                            [
                              _c("ul", { staticClass: "lbv-status-list" }, [
                                _c("li", { staticClass: "item" }, [
                                  _c("img", {
                                    staticClass: "lbv-icon leakIcon",
                                    attrs: {
                                      src: _vm._f("leakIcon")(
                                        _vm.deviceData.leak_status
                                      ),
                                      alt: "leak-icon",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "status label" }, [
                                    _vm._v("Low flow:"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "status value",
                                      attrs: {
                                        title: _vm._f("leakLabel")(
                                          _vm.deviceData.leak_status
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm._f("leakLabel")(
                                              _vm.deviceData.leak_status
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.analysingMode
                                  ? _c("li", { staticClass: "item" }, [
                                      _c("img", {
                                        staticClass: "lbv-icon analysingIcon",
                                        attrs: {
                                          src: _vm._f("analysingModeIcon")(
                                            _vm.analysingMode
                                          ),
                                          alt: "analysing-mode-icon",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "status label" },
                                        [_vm._v("Analysing mode")]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("li", { staticClass: "item" }, [
                                  _c("img", {
                                    staticClass: "lbv-icon signalIcon",
                                    attrs: {
                                      src: _vm._f("connectivityIcon")(
                                        _vm.deviceData.message_frequency_sm
                                      ),
                                      alt: "signal-icon",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "status label" }, [
                                    _vm._v("Connectivity:"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "status value",
                                      attrs: {
                                        title: _vm._f("connectivityLabel")(
                                          _vm.deviceData.message_frequency_sm
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm._f("connectivityLabel")(
                                              _vm.deviceData
                                                .message_frequency_sm
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "item" }, [
                                  _c("img", {
                                    staticClass: "lbv-icon batteryIcon",
                                    attrs: {
                                      src: _vm._f("batteryIcon")(
                                        _vm.deviceData.battery_sm
                                      ),
                                      alt: "battery-icon",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "status label" }, [
                                    _vm._v("Battery:"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "status value",
                                      attrs: {
                                        title: _vm._f("batteryLabel")(
                                          _vm.deviceData.battery_sm
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm._f("batteryLabel")(
                                              _vm.deviceData.battery_sm
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lbv-content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12 lbv-tabs-device" },
            [
              _c(
                "b-tabs",
                { attrs: { pills: "" }, on: { input: _vm.tabSwitchHandler } },
                [
                  _vm.PERMISSIONS.TAB[_vm.$store.getters.roleID].profile
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Profile", active: "" } },
                        [
                          _c("ProfileView", {
                            attrs: { "device-data": _vm.deviceData },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.PERMISSIONS.TAB[_vm.$store.getters.roleID].contact_notes
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Contact Notes" } },
                        [
                          _c("ContactNotes", {
                            attrs: { lb_id: _vm.deviceData.lb_id },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.PERMISSIONS.TAB[_vm.$store.getters.roleID].events
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Events" } },
                        [
                          _c("DeviceEventView", {
                            attrs: { lb_id: _vm.deviceData.lb_id },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.PERMISSIONS.TAB[_vm.$store.getters.roleID].deviceData
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Device Data" } },
                        [
                          _c("DeviceDataView", {
                            attrs: {
                              lb_id: _vm.deviceData.lb_id,
                              device_id: _vm.deviceData.leakbotId,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.PERMISSIONS.TAB[_vm.$store.getters.roleID].commsHistory
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Comms History" } },
                        [
                          _c("CommsHistoryView", {
                            attrs: { lb_id: _vm.deviceData.lb_id },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.PERMISSIONS.TAB[_vm.$store.getters.roleID].engBooking
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Eng Repair" } },
                        [
                          _c("EngineerBookingView", {
                            attrs: {
                              lb_id: _vm.deviceData.lb_id,
                              "leak-status": _vm.deviceData.leak_status,
                              "leakbot-id": _vm.deviceData.leakbotId,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.PERMISSIONS.TAB[_vm.$store.getters.roleID].admin
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Admin" } },
                        [
                          _c("AdminView", {
                            attrs: {
                              lb_id: _vm.deviceData.lb_id,
                              "high-usage-only": _vm.highUsageOnly,
                              "header-tank-checkbox": _vm.headerTankCheckbox,
                              "underfloor-heating-checkbox":
                                _vm.underfloorHeatingCheckbox,
                              "cold-void-checkbox": _vm.coldVoidCheckbox,
                              "unknown-checkbox": _vm.unknownCheckbox,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.PERMISSIONS.TAB[_vm.$store.getters.roleID].leakFree
                    ? _c(
                        "b-tab",
                        { attrs: { title: "Leak-Free Days" } },
                        [_c("LeakFreeView")],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }